import { initialState } from "../reducers/root.reducer";
import { IUtm } from "../../models/utm.interface";
import { UtmAction } from "../actions/utm.actions";
import { UtmActionTypes } from "../actions/types";

export const utmReducer = (
  state: IUtm | null = initialState.utm,
  action: UtmAction
) => {
  switch (action.type) {
    case UtmActionTypes.SET_UTM:
      return action.payload;
    default:
      return state;
  }
};
